import { render, staticRenderFns } from "./pageItem.vue?vue&type=template&id=1024043a&"
import script from "./pageItem.vue?vue&type=script&lang=js&"
export * from "./pageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports